import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export const PortalToID = ({
  id,
  children,
}: {
  id: string;
  children: React.ReactNode;
}) => {
  const [target, setTarget] = useState(null);

  useEffect(() => {
    const el = document.getElementById(id);
    if (el) setTarget(el);
  }, [id]);

  if (!target) return null; // nothing until available

  return createPortal(children, target);
};
